export default __webpack_public_path__ + "a2b0e1f2c69030a4b9b07aec12d8806c.svg";